import { capitalize, deburr, unescape } from 'lodash'

export const handleRoute = (route: string) => (route.startsWith('/') ? route : `/${route}`)

export const isWhiteCharacter = (value: string) => value === ' ' || value === '\f' || value === '\n' || value === '\r' || value === '\t' || value === '\v' || value === '\u00a0' || value === '\u1680' || value === '\u2000' || value === '\u2001' || value === '\u2002' || value === '\u2003' || value === '\u2004' || value === '\u2005' || value === '\u2006' || value === '\u2007' || value === '\u2008' || value === '\u2009' || value === '\u200a' || value === '\u2028' || value === '\u2029' || value === '\u202f' || value === '\u205f' || value === '\u3000' || value === '\ufeff'

export const textShortcut = (text: string, limit: number) => {
  if (text.length > limit) {
    let ending = false
    for (let i = limit - 3; i > -1; --i) {
      if (isWhiteCharacter(text[i])) {
        ending = true
      } else if (ending) {
        limit = i + 4
        break
      }
    }
    const part = text.substring(0, limit - 3)
    return `${part}...`
  }
  return text
}

export const decodeContent = (text: string) => unescape(text)

export const clearText = (str: string) => {
  return deburr(str
    .replace(/[~!@#$%\\^&/*|,.`=()№_+}\-{'":;>?<[\]]|[\d]/g, '')
    .replace(/[\s]{2,}/g, ' '),
  ).split(' ').map(capitalize).join(' ')
}

export const toAlias = (s = '') => s?.replace(/[_.-]/g, '.')

export const replaceWithData = (text: string, data: Record<string, unknown> = {}): string => {
  return text.replace(/\$\{(\w+)\}/g, (str: string, key: string) => {
    const value = data[key]
    return String(value)
  })
}

export const hideString = (text: string | number = '', start = 5, end = 5) => {
  return `${String(text).slice(0, start)}...${String(text).slice(-end)}`
}
